import {Grid, Typography} from "@mui/material";
import {Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot} from '@mui/lab';

const Pasos_Contactos = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={0}
            sx={{maxWidth:'1400px',pr:3, pt:4}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="h1"sx={{fontWeight: 800, fontSize: 30, color: '#223B59'}}>
                        ¿Cómo transformamos tu espacio?
                    </Typography>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="h2"sx={{fontWeight: 800, fontSize: 20, pt: 4, color: '#223B59'}}>
                        Paso 1: Escuchamos tu historia y analizamos tu espacio
                    </Typography>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="p"sx={{fontWeight: 100, fontSize: 16, pt: 1, pl: 4, color: '#223B59'}}>
                        Todo comienza con una conversación sincera. Nos cuentas cómo vives tu espacio, qué te incomoda y qué deseas cambiar y realizamos un diagnóstico funcional con base en:
                    </Typography>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="p" sx={{fontWeight: 600, fontSize: 16, pt: 4, pl: 4, color: '#223B59'}}>
                        Tus necesidades, rutina diaria y estilo de vida
                    </Typography>
                    <Grid container
                          justifyContent={'flex-start'}
                          alignItems={'flex-start'}
                          size={{xs: 12, sm: 12, md: 12}}>
                        <Typography component="p" sx={{fontWeight: 600, fontSize: 16, pt: 2, pl: 4, color: '#223B59'}}>
                            Las dimensiones reales de tu espacio.
                        </Typography>
                    </Grid>
                    <Grid container
                          justifyContent={'flex-start'}
                          alignItems={'flex-start'}
                          size={{xs: 12, sm: 12, md: 12}}>
                        <Typography component="p" sx={{fontWeight: 600, fontSize: 16, pt: 2, pl: 4, color: '#223B59'}}>
                            Posibilidades de redistribución, almacenamiento y diseño interior.
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="h2" sx={{fontWeight: 800, fontSize: 20, pt: 6, color: '#223B59'}}>
                        Paso 2: Déjanos tus datos y empezamos a diseñar
                    </Typography>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="p" sx={{fontWeight: 100, fontSize: 16, pt: 1, pl: 4, color: '#223B59'}}>
                        Con la información de tu espacio y tus expectativas, preparamos para ti:
                    </Typography>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="p" sx={{fontWeight: 600, fontSize: 16, pt: 2, pl: 4, color: '#223B59'}}>
                        Un plan de diseño personalizado enfocado en funcionalidad y estética.
                    </Typography>
                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography component="p" sx={{fontWeight: 600, fontSize: 16, pt: 2, pl: 4, color: '#223B59'}}>
                        Propuesta visual de los cambios.
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )

}
export default Pasos_Contactos;


